import React from 'react';
import { Vehicle } from '../../../../types/vehicle';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { initVehicleDetailsData } from '../../../../actions';

const Wrapper = styled.div`
  display: flex;
  height: 90px;
`;

const VehicleImage = styled.div<{ imageUrl: string }>`
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 90px;
  width: 120px;
  cursor: pointer;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
`;

type Props = {
  vehicle: Vehicle;
};

const ListerBar = styled.div<{ bg: string }>`
  height: 100%;
  width: 2px;
  background: ${props => props.bg};
`;

export const AdminVehicleImage = ({ vehicle }: Props) => {
  const dispatch = useDispatch();

  const handleOnClick = () => {
    dispatch(push(`/vehicles/${vehicle.id}/view`));
    dispatch(initVehicleDetailsData(vehicle));
  };

  const vehicleImageSrc = vehicle.preview_image?.url

  const bg = (() => {
    if (!vehicle.user?.referrer_user?.options?.color) return 'transparent';
    return vehicle.user?.referrer_user?.options?.color;
  })();

  return (
    <Wrapper>
      <ListerBar bg={bg} />
      <VehicleImage imageUrl={vehicleImageSrc} onClick={handleOnClick} />
    </Wrapper>
  );
};
